export const SCREEN_NAME = {
    RN_VIEW_JOB: 'rn-view-job',
    GHOSTWRITER_ONBOARDING: 'ghostwriter-onboarding-screen',
    GHOSTWRITER_REVIEW: 'ghostwriter-review-screen',
    /** Aligned with `myjobs/logging/constants` – My Jobs RN surface for Auto Apply tab events. */
    RN_MYJOBS: 'myjobs_react_native_screen',
} as const;

export const ELEMENT_NAME = {
    ENTRYPOINT_FIRST_TIME: 'ghostwriterEntrypointFirstTime',
    ENTRYPOINT_RETURNING: 'ghostwriterEntrypointReturning',
    ENTRYPOINT_THIRD_PARTY_APPLY: 'ghostwriterEntrypointThirdPartyApply',
    CONSENT_CONTINUE: 'ghostwriterConsentContinue',
    CONSENT_DISMISS: 'ghostwriterConsentDismiss',
    REVIEW_SAVE_AND_CLOSE: 'ghostwriterReviewSaveAndClose',
    REVIEW_SUBMIT: 'ghostwriterReviewSubmit',
    REVIEW_BACK: 'ghostwriterReviewBack',
    REVIEW_CLOSE: 'ghostwriterReviewClose',
    MYJOBS_AUTO_APPLY_OVERFLOW_MENU: 'ghostwriterAutoApplyOverflowMenu',
    MYJOBS_AUTO_APPLY_STOP_DIALOG: 'ghostwriterAutoApplyStopDialog',
    /** Manage this job bottom sheet – menu row or sheet close; `value` extra param disambiguates. */
    MYJOBS_AUTO_APPLY_MANAGE_JOB_MENU: 'ghostwriterAutoApplyManageJobMenu',
    /** Undo auto apply confirmation from manage job sheet (not the card stop-auto-apply flow). */
    MYJOBS_AUTO_APPLY_UNDO_MANAGE_JOB_DIALOG: 'ghostwriterAutoApplyUndoManageJobDialog',
} as const;

export const EVENT_TAG = {
    GHOSTWRITER: 'ghostwriter',
    /** Aligned with myjobs logging – events from the My Jobs Auto Apply UI. */
    MY_JOBS: 'myJobs',
} as const;

export const EVENT_NAME = {
    /** A single Ghostwriter form submission failure */
    FORM_SUBMISSION_ERROR: 'formSubmissionError',
    /** Same form failed submission enough times to look stuck/invalid */
    FORM_STUCK_STATE: 'formStuckState',
} as const;

export const EVENT_PARAMETER = {
    JOB_KEY: 'jobKey',
    GHOSTWRITER_STATE: 'ghostwriterState',
    VALUE: 'value',
    MYJOBS_SUB_TAB: 'myjobsSubTab',
    FORM_STEP: 'formStep',
    ERROR_REASON: 'errorReason',
    ATTEMPT_COUNT: 'attemptCount',
} as const;

/** Coarse form-step identifier for submission-error events. */
export const FORM_STEP = {
    REVIEW: 'review',
} as const;
export type GhostwriterFormStep = (typeof FORM_STEP)[keyof typeof FORM_STEP];

/**
 * Number of failed submissions of the same form (in one app session) that
 * flags a likely invalid/stuck state and triggers a `formStuckState` event.
 */
export const FORM_SUBMISSION_STUCK_THRESHOLD = 2;

/** My Jobs sub-tab label for Ghostwriter Auto Apply – aligned with `MYJOBS_LOGGING_TAB_NAME[ghostwriterAutoApply]`. */
export const MYJOBS_AUTO_APPLY_SUB_TAB = 'GhostwriterAutoApply';

export const MY_JOBS_SURFACE_TAGS = [EVENT_TAG.MY_JOBS];

export type GhostwriterAutoApplyCta =
  | 'review'
  | 'applyManually'
  | 'stopAutoApply'
  | 'updateStatus'
  | 'remove';

/** English button labels – match `GhostwriterAutoApplyJobCard` primary CTA copy (default locale). */
export const MYJOBS_AUTO_APPLY_CTA_ELEMENT_NAME: Record<GhostwriterAutoApplyCta, string> = {
  review: 'Review',
  applyManually: 'Apply manually',
  stopAutoApply: 'Stop auto apply',
  updateStatus: 'Update status',
  remove: 'Remove',
};
